const { useState } = require('react');

export const useFormValues = (initialValues) => {
    const [formValues, setFormValues] = useState(initialValues);

    function handleChange(e) {
        setFormValues((prev) => ({
            ...prev,
            [e.target.name]: e.target.files ? e.target.files : e.target.value,
        }));
    }

    return { formValues, handleChange, setFormValues };
};
